import { useState } from 'react';
import table from './image/table.png';
import { Popover, PopoverTrigger, PopoverContent } from '@leadsnavi/ui-kit';
import * as EditorTypeAll from '../tinymce';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}

const Table = ({ editorInstance }: Props) => {
  const [visible, setVisible] = useState(false);
  const [highlighted, setHighlighted] = useState<{ row: number; col: number } | null>(null);

  const TenByTenGrid = () => {
    const rows = 10;
    const cols = 10;
    const handleMouseEnter = (rowIndex: number, colIndex: number) => {
      setHighlighted({ row: rowIndex, col: colIndex });
    };
    const handleMouseLeave = () => {
      setHighlighted(null);
    };
    const gridItems = [];
    for (let i = 0; i < rows; i++) {
      for (let j = 0; j < cols; j++) {
        const isHighlighted = highlighted && i <= highlighted.row && j <= highlighted.col;
        gridItems.push(
          <div
            key={`${i}-${j}`}
            className="w-4 h-4 border border-gray-400 border-r border-b transition-colors duration-200 ease-in-out"
            style={{
              borderTop: i === 0 ? '1px solid #ccc' : 'none',
              borderLeft: j === 0 ? '1px solid #ccc' : 'none',
              backgroundColor: isHighlighted ? 'rgba(32, 122, 183, 0.5)' : 'transparent',
            }}
            onMouseEnter={() => handleMouseEnter(i, j)}
            onMouseLeave={handleMouseLeave}
            onClick={() => {
              highlighted &&
                editorInstance.execCommand('mceInsertTable', false, {
                  rows: highlighted.row + 1,
                  columns: highlighted.col + 1,
                });
              setVisible(false);
            }}
          />
        );
      }
    }

    return <div className="flex flex-wrap w-42 rounded-t-md overflow-hidden">{gridItems}</div>;
  };
  return (
    <Popover open={visible} onOpenChange={setVisible} modal={true}>
      <PopoverTrigger asChild>
        <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]">
          <img width="18px" height="18px" src={table} />
        </div>
      </PopoverTrigger>
      <PopoverContent className="p-0" side="top" align="start" sideOffset={5} style={{ zIndex: 9999 }}>
        <div>
          <TenByTenGrid />
          <div className="h-6 flex items-center justify-center">
            {highlighted ? `${highlighted.col + 1} x ${highlighted.row + 1}` : ''}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default Table;
